<template>
  <save-dialog
    title="Crear cliente"
    :show="show"
    @save="save"
    @changeValue="$emit('change', $event)">
    <v-layout row wrap slot="content">
      <v-flex xs12 md6 pr-4>
        <v-text-field
        @input="resetErrors"
        v-model="customer.first_name"
        v-validate="'required'"
        data-vv-name="first_name"
        data-vv-as="Nombre"
        :error-messages="errors.collect('first_name')"
        label="Nombre"
        color="black">
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <v-text-field
        @input="resetErrors" 
        v-model="customer.last_name"
        v-validate="'required'"
        data-vv-name="last_name"
        data-vv-as="Apellido"
        :error-messages="errors.collect('last_name')"
        label="Apellido"
        color="black">
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6 pr-4>
        <v-text-field
        @input="resetErrors" 
        v-model="customer.fiscal_id"
        v-validate="'required'"
        data-vv-name="rut"
        data-vv-as="RUT/DNI/CI"
        :error-messages="errors.collect('fiscal_id')"
        label="RUT/DNI/CI"
        color="black">
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6 >
        <v-select
          v-model="customer.gender"
          data-vv-name="gender"
          data-vv-as="Genero"
          :error-messages="errors.collect('gender')"
          label="Genero"
          item-value="id"
          item-text="name"
          :items="genders"
          color="black">
        </v-select>
      </v-flex>
      <v-flex xs12 md6 pr-4>
        <v-text-field
        @input="resetErrors" 
        v-model="customer.account"
        data-vv-name="account"
        data-vv-as="Cuenta"
        :error-messages="errors.collect('account')"
        label="Cuenta"
        color="black">
        </v-text-field>
      </v-flex>
      <v-flex xs12 md6 >
        <v-menu
          ref="birthday"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="customer.birthday"
          transition="scale-transition"
          min-width="290px"
          lazy
          offset-y
          full-width>
          <v-text-field
          @input="resetErrors"
            slot="activator"
            placeholder="Fecha de nacimiento"
            :value="formatDate(customer.birthday, 'YYYY-MM-DD', 'DD/MM/YYYY')"
            prepend-icon="event"
            readonly
            color="black">
          </v-text-field>
          <v-date-picker
            v-model="customer.birthday"
            @input="$refs.birthday.save(customer.birthday)"
            locale="es"
            type="date"            
            color="k-orange-linear">
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
  </save-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import SaveDialog from '@/components/global/SaveDialogV2';
import clearFormMixin from '@/mixins/clearForm';
import formatDateMixin from '@/mixins/formatDate';

export default {
  inject: ['$validator'],
  props: {
    chatCenter: {
      type: Number,
      default: 0,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SaveDialog,
  },
  mixins: [
    clearFormMixin,
    formatDateMixin,
  ],
  data() {
    return {
      customer: {
        first_name: '',
        last_name: '',
        fiscal_id: '',
        gender: '',
        account: '',
        birthday: '',
      },
    };
  },
  computed: {
    ...mapGetters([
      'genders',
    ]),
  },
  methods: {
    resetErrors() {
      if (this.errors.any()) {
        this.errors.clear();
      }
    },
    save() {
      const obj = this.customer;
      if (this.chatCenter) {
        obj.chatCenter = this.chatCenter;
      }
      this.axios.post('customer', obj).then(() => {
        this.$emit('change', false);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customer/CreateCustomerDialog.vue